import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { RfpCoveragesResponse } from "./types";
import { useApi } from "./ApiContext";

interface UseRfpCoveragesOptions<TSelected> {
  rfpId: string;
  enabled?: boolean;
  select?: (data: RfpCoveragesResponse) => TSelected;
}

export const getRfpCoveragesQueryKey = (rfpId: string): string[] => [
  "rfps",
  rfpId,
  "coverages",
];

export const getRfpCoveragesEndpoint = (rfpId: string): string =>
  `brokerportal/v1/rfp/${rfpId}/coverages`;

// useRfpCoverages with selector overload
export function useRfpCoverages<TSelected>(options: {
  rfpId: string;
  enabled?: boolean;
  select: (data: RfpCoveragesResponse) => TSelected;
}): UseQueryResult<TSelected, Error>;

// useRfpCoverages with default select for all RFP coverages response data
export function useRfpCoverages(options: {
  rfpId: string;
  enabled?: boolean;
}): UseQueryResult<RfpCoveragesResponse, Error>;

// useRfpCoverages fetches coverages for an RFP project
export function useRfpCoverages<TSelected = RfpCoveragesResponse>({
  rfpId,
  enabled = true,
  select,
}: UseRfpCoveragesOptions<TSelected>): UseQueryResult<TSelected, Error> {
  const axios = useApi();
  return useQuery({
    queryKey: getRfpCoveragesQueryKey(rfpId),
    enabled,
    select,
    queryFn: () =>
      axios
        .get<RfpCoveragesResponse>(getRfpCoveragesEndpoint(rfpId))
        .then((res) => res.data),
  });
}
